// extracted by mini-css-extract-plugin
module.exports = {"component":"user_component_1DYMX","image":"user_image_2KzQr","name":"user_name_1Ia2h","username":"user_username_1r8R4"};